
























import Vue from "vue";

import AudioPlaybackButton from "@tt-app/components/control/AudioPlaybackButton.vue";
import JzCheckbox from "@tt-app/components/ui/input/JzCheckbox.vue";

import IconUserVoice from "@joyz/app-core/assets/icons/default/UserVoice.svg";
import IconSpeaker from "@joyz/app-core/assets/icons/default/Speaker.svg";
import {
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";

interface Data {
  icons: { [key: string]: string };
}

interface Methods {
  reviewSentenceClickHandler: (event: MouseEvent) => void;
}

interface Computed {
  audioSource: string;
  checkboxAvailable: boolean;
  limitedModeActive: boolean;
  problemUuid: string;
  singleExampleAudio: boolean;
  userVoiceSource: string;
}

interface Props {
  answers: any;
  audioConfig: {
    accent: number;
    speed: number;
  };
  audioProgress: number;
  body: any[];
  checked: boolean;
  exampleAudioButtonClickHandler: () => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ReviewSentence",
  components: {
    AudioPlaybackButton,
    JzCheckbox
  },
  props: {
    answers: {
      type: Object,
      required: true
    },
    audioConfig: {
      type: Object,
      required: true
    },
    audioProgress: {
      type: Number,
      required: true
    },
    body: {
      type: Array,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    exampleAudioButtonClickHandler: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      icons: {
        speaker: IconSpeaker,
        userVoice: IconUserVoice
      }
    };
  },

  computed: {
    audioSource() {
      if (this.singleExampleAudio) {
        return this.body[0].audioFiles;
      }

      const { accent, speed } = this.audioConfig;

      const accents: { [key: number]: string } = {
        0: "US",
        1: "GB",
        2: "AU"
      };

      return this.body[0].audioFiles[accents[accent]][speed];
    },
    checkboxAvailable() {
      return !this.limitedModeActive;
    },
    limitedModeActive() {
      const session = this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.ACTIVE_SESSION}`
      ];

      return Boolean(session?.limitedMode?.id);
    },
    problemUuid() {
      return this.body[0].problemUuid;
    },
    singleExampleAudio() {
      return typeof this.body[0].audioFiles === "string";
    },
    userVoiceSource() {
      return this.answers[this.problemUuid].audio;
    }
  },

  methods: {
    reviewSentenceClickHandler(event) {
      if (this.limitedModeActive) return;

      if (!event.target) return;

      const target = event.target as HTMLElement;

      if (target.closest(".dictionary-sentence")) {
        if (target.classList.contains("defined")) return;
      }

      if (target.classList.contains("audio-playback-button__icon")) return;

      this.$emit("selected", this.body[0].problemUuid);
    }
  }
});
